var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C9C9C9;}\n\t.st1{fill:#303030;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st0",
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,21.2c-0.3,0-0.5-0.2-0.5-0.5V9.2c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v11.5C15.5,21,15.3,21.2,15,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.7,15.5H9.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h11.4c0.3,0,0.5,0.2,0.5,0.5 C21.2,15.3,21,15.5,20.7,15.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFix);
export default __webpack_public_path__ + "static/media/fix.d64f18496f264b06da869f79912bf0d4.svg";
export { ForwardRef as ReactComponent };